import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 917B10C1-CFB6-4066-9977-0FA6DD835C0E
 * name arrow-left-right-bold
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-right-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftRightBoldIcon = createSvgIcon(<><path d="M8,14V18L2,12L8,6V10H16V6L22,12L16,18V14H8Z" /></>, 'ArrowLeftRightBoldIcon');
export default ArrowLeftRightBoldIcon